<template>
	<div class="page">



		<!-- header -->
		<div class="center center-padding" id="header" style="margin-top:5px;background:white;">

			<BreadcrumbToolbar :categoryModel="this.baseCategoryModel" :category="this.category"
				@categorySelected="(category) => this.categorySelected(category)" :previousProduct="this.previousProduct"
				@previous="(() => this.previous())" :nextProduct="this.nextProduct" @next="(() => this.next())"
				style="border:0px solid red;" />
			<!-- FP: :productSpinner="this.productSpinner" @reload="(() => this.reloadPressed())"-->


		</div>

		<div class="center" v-if="this.product" style="background:var(--grey-2);">

			<!-- imageListLarge -->
			<div v-show="this.showImageListLarge"
				style="background:white;position:fixed;top:0px;left:0px;width:100vw;z-index:100;border:0px solid red;">

				<div id="imageListLarge" class="flexcenter" ref="imageListLarge"
					:class="this.showImageListLarge ? 'imageListLargeShow':'imageListLargeHide'"
					style="width:100%;height:100vh;max-height:100%;overflow-x:scroll;overflow-y:hidden;scroll-snap-type: x mandatory;margin:0 auto;max-width:1400px;"
					@scroll="(() => { this.onScrollLarge() })">

					<div
						style="position:fixed;background: transparent;color:white;top:0px;width:100%;max-width:1400px; text-align:center">
						<div class="flexcenter" style="background-color: transparent;">

							<!-- indikator large -->
							<div v-if="this.imagePathList?.length > 1" style="flex-grow:1;justify-content:center;" class="flexcenter">
								<div class="flexcenter"
									style="background:rgba(0, 0, 0, 0.8);border-radius: 30px;padding-left:10px;padding-right:10px;height:30px;gap:7px;margin-left:40px;">
									<div v-for="(_, index) in this.imagePathList" :key="index"
										@click.stop="this.showFullSize('image-large-' + index, 'smooth');">
										<Circle v-if="index == this.largeImageIndex" fileName="" color="white" size="10px" />
										<Circle v-if="index != this.largeImageIndex" fileName="" color="--grey-dark-2" size="10px" />
									</div>
								</div>
							</div>
							<div v-else style="flex-grow:1;">&nbsp;</div>
							<Circle @click.stop="this.showImageListLarge = false" style="margin-right:10px;margin-top:10px;"
								color="--grey-dark-2" hover="black" padding="23%" fileName="w3_close_white" />
						</div>

					</div>

					<!-- imageLarge FP: Fullsize-->
					<div v-for="(imagePath, index) in this.imagePathList" :key="imagePath" class="" ref="imageLarge"
						style="height:100%;scroll-snap-align: center;" :id="'image-large-' + index"
						@click.self="this.showImageListLarge = false">

						<img :src="imagePath.path"
							style="height:calc(100vh - 0px);width:100vw;max-width:1400px; object-fit: contain;background:white;"
							title="Klicka för att stänga" @click.self="this.showImageListLarge = false" />


					</div>
					<div v-if="this.showLeftIconLarge" style="" class="link largeImageArrowLeft"
						@click.stop="this.showPreviousLargeImage()">
						<Circle fileName="w3_chevron_left_light" color="" hover="" class="arrow" />
					</div>
					<div v-if="this.showRightIconLarge" style="" class="largeImageArrowRight"
						@click.stop="this.showNextLargeImage()">
						<Circle fileName="w3_chevron_right_light" color="" hover="" class="arrow" />
					</div>
				</div>

			</div>

			<!-- hela bredden -->


			<div id="productView" class="flexcenter" style="">

				<!-- wrapper till kolumn med imageMedium och imageSmallList -->
				<div id="imageMediumWrapper" class="flexcenter" style="">

					<div v-if="!this" class="mobile" style="background:red; width:100%;margin-bottom:10px;">
						<BreadcrumbToolbar :categoryModel="this.baseCategoryModel" :category="this.category"
							@categorySelected="(category) => this.categorySelected(category)" :previousProduct="this.previousProduct"
							@previous="(() => this.previous())" :nextProduct="this.nextProduct" @next="(() => this.next())"
							:productSpinner="this.productSpinner" @reload="(() => this.reloadPressed())" />
					</div>

					<div style="width:100%;position:relative;">


						<!-- imageListMedium -->
						<div id="imageListMedium" class="flexcenter" ref="imageListMedium"
							style="width:100%;height:60vw;max-height:600px;overflow:scroll;scroll-snap-type: x mandatory;background:white;"
							@scroll="(()=> { this.onScrollMedium() } )">

							<!-- bild div -->
							<div v-for="(imagePath, index) in this.imagePathList" :key="imagePath" class="image imageMediumWrapper"
								ref="imageMedium" style="" :id="'image-medium-' + index">

								<img :src="imagePath.path" style="" class="imageMedium"
									@click="this.showFullSize('image-large-' + index)" :title="'image-medium-' + index" />

							</div>

						</div>
						<div v-if="this.showLeftIconMedium" style="position:absolute;top:calc(50% - 15px);left:0px;"
							@click="showPreviousMediumImage()">
							<Circle fileName="w3_chevron_left_light" color="" hover="" size="20px" />
						</div>
						<div v-if="this.showRightIconMedium" style="position:absolute;top:calc(50% - 20px);right:0px;"
							@click="showNextMediumImage()">
							<Circle fileName="w3_chevron_right_light" color="" hover="" size="20px" style="margin-right:5px;" />
						</div>
					</div>




					<!-- imageListSmall -->
					<div id="imageListSmall" v-if="this.imagePathList?.length > 1" class="flexcenter desktop" ref="imageListSmall"
						style="width:100%;height:150px;overflow:scroll;scroll-snap-type: x mandatory;"
						@scroll="(() => { this.onScrollSmall() })">
						<!-- lista bilderna -->
						<div v-for="(imagePath, index) in this.imagePathList" :key="imagePath"
							style="align-items: center;display:flex;height:150px;scroll-snap-align: start;">
							<img :src="imagePath.path" style="height:140px;width:140px;object-fit: contain;padding:5px;"
								@click="this.scrollToImage('image-medium-' + index, 'smooth')" :title="'image-small-' + index " />

						</div>
					</div>

					<!-- indikator small -->
					<div class="mobile" style="background: white;">
						<div class="flexcenter" style="gap:5px;">
							<div v-for="(_, index) in this.imagePathList" :key="index">

								<b v-if="index == this.mediumImageIndex" style="color:darkgrey;padding: 0;">
									<Circle fileName="" color="--grey-dark-2" size="10px" />
								</b>

								<b v-if="index != this.mediumImageIndex">
									<Circle fileName="" color="--grey-5" size="10px" />
								</b>
							</div>
						</div>
					</div>

				</div>

				<!-- produktdetaljer -->
				<div id="details" style="background:white; ">


					<div style="padding-left:10px;padding-right:10px;border:0px solid purple;">
						<!--wrapper för padding, padding i sidled -->

						<BreadcrumbToolbar v-if="!this" class="desktop" :categoryModel="this.baseCategoryModel"
							:category="this.category" @categorySelected="(category) => this.categorySelected(category)"
							:previousProduct="this.previousProduct" @previous="(() => this.previous())"
							:nextProduct="this.nextProduct" @next="(() => this.next())" :productSpinner="this.productSpinner"
							@reload="(() => this.reloadPressed())" />





						<div class="flexcenter" style="text-align:left;font-weight:bold;color:grey;">
							<b style="flex-grow:1;font-size:80%;">{{ this.product.manufactorName }}</b>


						</div>

						<div style="overflow-wrap: break-word;">
							<h3 style="font-size: min(20px, calc(1.2vw + 13px));margin-top:5px;">{{ this.product.name }}</h3>
						</div>

						<div style="margin-top:10px;color:grey;font-size:90%;">
							<span v-html="this.descriptionShort"></span>
							<br />
							<div v-if="this.showReadMore" class="link" @click="this.showDescription()"
								style="display:flex;align-items: center;margin-top:5px; background:white;color:grey;border-radius: 3px; padding-left:0px;padding-right:5px;font-size:90%;font-weight: bold;">
								Läs mer
								<Icon fileName="w3_chevron_right_dark" style="width: 6px;height:10px;margin-left:5px;" />
							</div>
						</div>



						<div class="flexcenter" style="align-items:start; margin-top:10px;margin-top:15px;">

							<div class="flexcenter" style="flex-direction: column;align-items: start;flex-grow:1;">
								<b style="font-size: min(20px, calc(1.2vw + 13px));"
									:class="this.isOutlet(this.productId) ? 'outlet-price' : '' " :title="this.priceTitle">{{
									this.formatPrice(this.product) }}</b>

								<div v-if="this.isLoggedIn && this.displayPrice && this.product?.details?.productOptionCount == 0"
									style="margin-top:5px;flex-direction: column;align-items: start;width:100%;" class="flexcenter">

									<div class="flexcenter" style="">

										<div v-if="this.product?.details?.discountModel?.success" class="discountBadge link"
											@click="this.showDiscountInformation = !this.showDiscountInformation"
											style="font-size:80%;margin-right:5px;">{{
											this.product?.details?.discountModel?.label }}</div>

										<div style="color:grey;">
											{{ this.formatPrice1(this.product?.details?.price1) }}
										</div>

									</div>




								</div>

							</div>





							<div v-if=" !this" class="noInStock" :class="'noInStock_' + this.product.noInStockKey"
								style="padding:5px;border-radius:5px;color:white;font-weight:bold; padding-left:20px;padding-right:20px;">
								{{ this.noInStockLabel(this.product.noInStockKey) }}
							</div>


							<div v-if="!this.hasProductOptions" class="flexcenter" style="flex-direction: column;align-items: end;">

								<div v-if="this.isLoggedIn" class="link" @click="this.buy()"
									style="padding:5px;border-radius:5px;color:white;font-weight:bold; padding-left:50px;padding-right:50px;background:var(--bg-message);margin-bottom:5px;">
									KÖP


								</div>


								<div class="noInStock	" :class="'noInStock_' + this.product.noInStockKey"
									style="font-size:70%;color:white;font-weight:bold;padding:5px;display: inline;border-radius: 5px;">
									{{
									this.noInStockLabel(this.product.noInStockKey) }}</div>

							</div>




						</div>

						<div
							v-if="this.isLoggedIn && !this.hasProductOptions && showDiscountInformation && this.product?.details?.discountModel && this.product?.details?.discountModel?.success"
							style="margin-top:10px;">
							<DiscountModelView :discountModel="this.product?.details?.discountModel" />
						</div>

						<DeliveryTime
							v-if="this.isLoggedIn && !this.hasProductOptions && this.showDeliveryTimeForProduct(this.product)"
							:product="this.product" style="margin-top:10px;" />


						<!-- dropship -->
						<div v-if="this.isLoggedIn && this.settingEnableDropship"
							style="background:var(--grey-2);padding:5px;border-radius: 5px;margin-top:10px;">
							<div style="display: flex;flex-direction: column;">

								<div class="flexcenter link" @click="this.showDropship = !this.showDropship">
									<Circle fileName="w3_package_thin_white" color="--bg-message" size="35px"
										style="margin-right:5px;margin-left:5px;" />
									<b style="flex-grow:1;">Direktleverans till kund / dropship</b>
									<Button v-if="this.showDropship" label="Avbryt" class="error" @click.stop="this.resetDropship()" />
									<Icon v-if="!this.showDropship" fileName="w3_chevron_down_grey"
										style="width:15px;height:15px;margin-right:5px;" />
								</div>
								<div v-if="this.showDropship"
									style="background: white; padding:5px;border-radius: 5px;margin-top:10px;">

									<WebContent name="PRODUCT_DROPSHIP_INFO" style="font-size:90%;font-weight: bold;color:grey;" />

									<div class="flexcenter"
										style="margin-top:20px;background:white;padding:5px;border-radius: 5px;border:1px solid lightgray;">
										<input type="text" v-model="this.dropship.email"
											style="width:calc(100% - 20px);padding:5px;border:0px solid transparent;outline:none;"
											placeholder="Kundens e-post" @keypress="this.dropship.error = null" />
										<Circle fileName="w3_close_white" size="20px" padding="25%" color="--grey-5"
											@click="this.dropship.email = ''" />

									</div>

									<!-- fortsätt (product-option) -->
									<div v-if="this.hasProductOptions && !this.dropship.active" class="flexcenter"
										style="margin-top:10px;justify-content: flex-end;">
										<Button label="Fortsätt" @click="this.dropship.active = true" style="margin-top:10px;" />
									</div>


									<!-- antal -->
									<div v-if="this.dropship.active || !this.hasProductOptions" class="flexcenter"
										style="align-items: center;margin-top:10px;">
										<b style="flex-grow:1;">Antal</b>
										<div class="flexcenter"
											style="background:white;padding:5px;border-radius: 5px;border:1px solid lightgray;max-width:200px;">
											<input type="text" v-model="this.dropship.quantity"
												style="width:calc(100% - 20px);padding:5px;border:0px solid transparent;outline:none;"
												placeholder="Antal" @keypress="this.dropship.error = null" />
											<Circle fileName="w3_close_white" size="20px" padding="25%" color="--grey-5"
												@click="this.dropship.quantity = '1'" />

										</div>

									</div>




									<div v-if="this.dropship.active" class="flexcenter" style="margin-top:10px;">
										<b style="flex-grow:1;">Artikelnummer</b>
										<div v-if="!this.dropship.productOptionSetId">
											Välj produktvariant nedan!
										</div>
										<div v-if="this.dropship.productOptionSetId > 0">
											<b>{{ this.dropship.productOptionSetLabel }}</b>
										</div>


									</div>

									<div v-if="this.dropship.error" @click="this.dropship.error = null" class="link"
										style="background:var(--bg-error);margin-top:10px;padding:5px;color:white;border-radius: 5px;">
										{{this.dropship.error}}
									</div>


									<div v-if="this.dropship.active || !this.hasProductOptions" class=" flexcenter"
										style="margin-top:20px;justify-content: flex-end;">



										<Button label="Skapa dropship-order" :class="this.canSendDropship ? '' : 'grey' "
											@click.stop="this.createDropshipOrder()" :spinIconRight="this.createDropshipOrderSpinner == true"
											:iconRight="this.createDropshipOrderSpinner ? 'spinner.png' : null" />

									</div>


								</div>
							</div>

						</div>




						<div v-if=" !this && !this.hasProductOptions" style="margin-top:10px;color:grey;">
							<b>{{ this.formatArtnr(this.product.artnr) }}</b>
						</div>

						<div v-if="this.debug" class="flexcenter debug" style="margin-top:10px;">

							<!-- page width -->
							<div id="width1400" style="background: lightcoral;color:white;padding:5px;border-radius: 5px;">1400
							</div>
							<div id="width1390" style="background: darkslateblue;color:white;padding:5px;border-radius: 5px;">1390
							</div>
							<div id="width1100" style="background: orange;color:white;padding:5px;border-radius: 5px;">1100</div>
							<div id="width900" style="background: limegreen;color:white;padding:5px;border-radius: 5px;">900</div>
							<div id="width768" style="background: lightseagreen;color:white;padding:5px;border-radius: 5px;">768
							</div>
							{{ this.layout.key }}
						</div>

						<!-- productOptionList RIGHT / visas även nedan -->
						<div v-if="this.hasProductOptions" id="productOptionListRight" style="margin-top:20px;">

							<b style="">Produktvarianter</b>
							<ProductOptionList :productOptionModel="this.productOptionModel"
								@buyProductOption="((productOptionSet) => this.buyProductOption(productOptionSet))"
								style="margin-top:5px;" :dropshipActive="this.dropship.active"
								:dropshipProductOptionSetId="this.dropship.productOptionSetId" />

							<div v-if="this.isLoggedIn && this.showDeliveryTimeForProductOptionSet(this.product)"
								style="margin-top:10px;">

								<DeliveryTime :product="this.product" />
							</div>



						</div>




						<!-- egenskaper -->
						<div style="margin-top:20px;">
							<b style="color:black;">Produktegenskaper</b>
							<table id="propertyList" cellpadding="0" cellspacing="0" style="width:100%;margin-top:10px;">
								<tr style="background:var(--grey-3); ">
									<td class="label">Artikelnummer</td>
									<td v-if="!this.hasProductOptions" class="value">{{ this.formatArtnr(this.product?.artnr) }}</td>
									<td v-if="this.hasProductOptions" class="value">Se respektive variant</td>
								</tr>
								<tr class="odd">
									<td class="label">EAN</td>
									<td v-if="!this.hasProductOptions" class="value">{{ this.product?.ean }}</td>
									<td v-if="this.hasProductOptions" class="value">Se respektive variant</td>
								</tr>
								<tr style="background:var(--grey-3);">
									<td class="label">Varumärke</td>
									<td class="value">
										<div class="flexcenter link" @click="this.showManufactor = !this.showManufactor">
											<span style="">{{ this.product?.manufactorName }}</span>
											<Icon :fileName="this.showManufactor ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark' "
												style="width:12px;height:12px;margin-left:3px;" />
										</div>


									</td>
								</tr>
								<tr>
									<td></td>
									<td colspan="" style="text-align:left;">
										<div v-if="this.showManufactor" style="">

											<div style="height:auto;max-height: 200px; width:200px;background:white;">
												<img :src="this.src" style="object-fit: contain;width:100%;height:100%;" />


											</div>
											<div class="flexcenter"
												style="width:calc(100% - 10px);margin-top:10px;margin-bottom:10px;justify-content: start;">
												<b class="link" style="color:grey;font-size:80%;" @click="this.manufactorSelected();">Visa
													produkter från {{ this.product?.manufactorName }}</b>
												<Icon fileName="w3_chevron_right_dark" style="width:8px;height:12px;margin-left:5px;" />

											</div>



										</div>
									</td>
								</tr>


								<tr v-for="(productOption, index) in this.productOptionListWithSameValue" :key="index"
									:class="{ odd: index % 2 === 0 }">
									<td class="label">
										{{ productOption?.typeWeb }}
									</td>
									<td class="value">
										{{ productOption?.value }}
									</td>

								</tr>
							</table>
						</div>

						<!-- specifikation -->
						<div v-if="this.product.details?.specification?.length > 10" style="margin-top:20px">
							<SpecificationHTML :specification="this.product.details?.specification" />
						</div>

						<div id="delivery" style="background-color: var(--grey-3);padding:10px;margin-top:20px;border-radius: 5px;">
							<div class="flexcenter" style="gap:10px;">
								<DeliveryCell title="Köp i butik" subtitle="Sök butik nedan" fileName="w3_location_light" />
								<DeliveryCell title="Hemleverans" subtitle="Skickas från butik" fileName="w3_delivery_light" />
								<DeliveryCell title="Upphämtning" subtitle="Skickas till butik" fileName="w3_store_light" />

							</div>

							<ProductResellerView :productTypeKey="this.product?.pt" />


							<div class="flexcenter link" style="margin-top:10px;margin-bottom:10px; "
								@click="this.toggleFavorite(this.productId)">

								<div v-if="this.isFavorite(this.productId)" class="flexcenter">
									<Icon fileName="w3_bookmark_solid_grey" style="height:20px;width:15px;margin-right:5px;" /> <b
										class="font-smaller">Favoritmarkerad</b>
								</div>


								<div v-if="!this.isFavorite(this.productId)" class="flexcenter">
									<Icon fileName="w3_bookmark_light" style="height:20px;width:15px;margin-right:5px;" /> <b
										class="font-smaller">Favoritmarkera</b>
								</div>

							</div>


							<div class="flexcenter link" @click="this.reloadPressed()">
								<Icon fileName="w3_reload_light" :class="this.productSpinner ? 'spinner' : '' "
									style="height:15px;width:15px;margin-right:5px;" />
								<b class="font-smaller">Ladda om produkten</b>


							</div>

							<div v-if="this.debug" class="flexcenter link" @click="this.deleteProductPressed()"
								style="margin-top:10px;">
								<Icon fileName="w3_trash_light" style="height:15px;width:15px;margin-right:5px;" />
								<b class="font-smaller">Radera produkten (test)</b>


							</div>


						</div>


						<div style="height:10px;">&nbsp;</div>




						<div v-if="this.debug">
							this.smallImageIndex: {{ this.smallImageIndex }} <br />
							this.mediumImageIndex: {{ this.mediumImageIndex }} <br />
							this.largeImageIndex: {{ this.largeImageIndex }} <br />
							PreviousProduct: {{ this.previousProduct?.productId }} {{ this.previousProduct?.artnr }} <br />
							NextProduct: {{ this.nextProduct?.productId }} {{ this.nextProduct?.artnr }} <br />

							categoryIdList: {{ this.categoryIdList }} - categoryId: {{ this.categoryId }}
							<hr />
							ProductType: {{ this.productTypeSelected }}
							<hr />
							RouteName: {{ this.$route.name }}<br />

							<hr />
							Route:{{ this.$route.params }}
							<hr />
							category: {{ this.category }}

							<br />
							<Button v-if="!this.product.details" label="Hämta detaljer" @click="this.getProductDetails()" />
						</div>
					</div>
				</div>

			</div>

			<div id="below" style="background:white;padding:10px;">


				<div v-if="this.hasProductOptions" id="productOptionListBelow" style="margin-bottom:20px;">
					<h3 style="color:grey;">Produktvarianter</h3>

					<ProductOptionList :productOptionModel="this.productOptionModel"
						@buyProductOption="((productOptionSet) => this.buyProductOption(productOptionSet))" style="margin-top:10px;"
						:dropshipActive="this.dropship.active" :dropshipProductOptionSetId="this.dropship.productOptionSetId" />

					<DeliveryTime v-if="this.showDeliveryTimeForProductOptionSet(this.product)" :product="this.product"
						style="margin-top: 10px;" />

				</div>
				<div v-if="this" id="product-description" ref="product-description">
					<h3 style="color:grey;">Produktbeskrivning</h3><br />
					<span v-html="this.product.details?.description"></span>
				</div>
				<div v-if="this" id="itemList" style="margin-top:20px;">
					<ItemList :productId="this.productId" style="margin-top:10px;" />
				</div>

				<!-- passar till mc -->
				<div v-if="this.fitMcModel?.brandNameList?.length > 0" style="margin-top:20px;">

					<h3 style="color:grey;">Passar till MC-modell</h3>
					<div style="max-height: 400px;overflow-y: scroll;margin-top:10px;">
						<div v-for="brandName in this.fitMcModel?.brandNameList" :key="brandName"
							style="background:var(--grey-2);padding:10px;border-radius: 5px;">
							<b v-if="this.fitMcModel?.brandNameList?.length > 0" style="display:inline-block; margin-bottom:5px;">{{
								brandName }}</b>
							<div style="display: flex; flex-direction: column;gap:5px;" class="">


								<div v-for="mc in (this.fitMcModel?.mcMap?.get(brandName) || [])" :key="mc.mcId"
									style="margin-bottom:0px;margin-top:0px;" class="link flexcenter"
									@click.stop="this.mcSelected(mc.brand, mc.mcModel, null)" :title="this.titleMc(mc)">
									<div style="margin-bottom: 0px;">

										<b style="color:grey;" class="font-smaller">{{ brandName }} {{ mc?.mcModel?.modelName }}</b>
									</div>
									<div class="flexcenter" style="margin-left:10px;">
										<div v-for="year in (mc?.yearList || [])" :key="year.year" class="link font-smaller"
											style="background:var(--grey-4);padding:3px;border-radius: 3px;"
											@click.stop="this.mcSelected(mc.brand, mc.mcModel, year)" :title="this.titleMcYear(mc, year)">
											<span>{{ year.year }}</span>
										</div>
									</div>




								</div>
							</div>
						</div>
					</div>

				</div>

				<!-- Finns i kategori -->
				<div v-if="this.inCategoryList?.length > 0" style="margin-top:20px;">
					<h3 style="color:grey;"> {{ this.inCategoryList?.length == 1 ? 'Finns i produktkategori' :
						'Finns&nbsp;i&nbsp;produktkategorier' }}</h3>
					<div v-for="inCategory in this.inCategoryList" :key="inCategory.category.categoryId"
						style="padding:5px;background:var(--grey-2);margin-top:10px;">

						<div class="flexcenter" style="">
							<div v-for="(category, index) in inCategory.categoryPath" :key="category.categoryId" class="flexcenter"
								style="padding:0px;gap:0px;">


								<div style="" class="link" @click="this.categorySelected(category)"
									:title="this.titleCategory(category)">
									<span style="" class="font-smaller">{{ category.name }}</span>
								</div>


								<div v-if="(index + 1) < inCategory.categoryPath?.length " style="margin-left:10px;margin-right:5px;">
									<Icon fileName="w3_chevron_right_dark" style="width:6px;height:10px;" />
								</div>

							</div>
						</div>

					</div>
				</div>

				<!-- liknande produkter -->
				<div v-if="this.connectedProductIdList && this.connectedProductIdList.length > 0"
					style="margin-top:20px;margin-bottom:20px;">
					<h3 style="color:grey;">Liknande produkter</h3>
					<ProductListView :productIdList="this.connectedProductIdList" style="margin-top:10px;" />
				</div>

				<!-- nyligen visade produkter -->
				<div v-if="this.viewedProductIdList && this.viewedProductIdList?.length > 0"
					style="margin-top:20px;margin-bottom:20px;">
					<h3 style="color:grey;">Nyligen visade produkter</h3>
					<ProductListView :productIdList="this.viewedProductIdList" style="margin-top:10px;" />
				</div>




				<div v-if="debug" class="debug" style="color:white;max-width:100%;">

					<pre style="overflow:scroll;">
					{{ product }}
				</pre>

				</div>

			</div>
		</div>
		<div class="center" v-if="!this.product"
			style="background:var(--grey-2);padding:10px;margin-bottom:20px;margin-top:20px;">
			Kunde inte hitta produkten
		</div>


		<Footer />


	</div>
</template>
<script>

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';
import { productMixin } from "@/mixins/productMixin.js";
import { routerMixin } from "@/mixins/routerMixin.js";
import { settingsMixin } from "@/mixins/settingsMixin.js";
import { userMixin } from '@/mixins/userMixin';
import { productSearchMixin } from '@/mixins/productSearchMixin';
import settings from "@/settings";

import { STORE_GETTER } from "@/store/store";
import listHelper from "@/helper/list-helper.js";
import categoryHelper from "@/helper/category-helper.js";
import ProductOptionList from "./ProductOptionList.vue";
import ProductListView from "./ProductListView.vue";
import { PRODUCT_STORE_COMMIT, PRODUCT_STORE_GETTER } from "../../../store/product-store";
import ItemList from "./ItemList.vue";
import { STORE_ACTION, STORE_COMMIT } from "../../../store/store";
import { USER_STORE_ACTION, USER_STORE_GETTER } from "../../../store/user-store";
import BreadcrumbToolbar from "./BreadcrumbToolbar2.vue";
import DeliveryCell from "./DeliveryCell.vue";
import DeliveryTime from "./DeliveryTime.vue";
import DiscountModelView from "./DiscountModelView.vue";
import Footer from "../../../components/Footer.vue";
import ProductResellerView from "../../../components/reseller/ProductResellerView.vue";
import WebContent from "../../../components/WebContent.vue";
import SpecificationHTML from "./SpecificationHTML.vue";

export default {
	name: "ProductDetails",
	components: { ProductOptionList, ProductListView, ItemList, BreadcrumbToolbar, DeliveryCell, DeliveryTime, DiscountModelView, Footer, ProductResellerView, WebContent, SpecificationHTML },
	mixins: [productMixin, routerMixin, userMixin, settingsMixin, productSearchMixin],
	props:{
		productId: Number, // kan också vara satt via url och är då en string
		productTypeKey:String,
	},
	data() {
		return {
			spinner: false,
			productSpinner: false,
			//productId: null,
			selectedImagePath: null,
			showImageListLarge: false,
			showManufactor:false,
			smallImageIndex: 0,
			mediumImageIndex: 0,
			largeImageIndex: 0,
			showDiscountInformation: false,
			layoutList: [
				{
					key: "60-40", 
					imageWrapperWidth: "60%",
					imageMediumWidth: "60vw",
					imageMediumMaxWidth: "840px",
					detailsWidth: "calc(40% - 10px)",
				},
				{ key: "50-50", 
					imageWrapperWidth: "50%",
					imageMediumWidth: "50vw",
					imageMediumMaxWidth: "700px",
					detailsWidth: "calc(50% - 10px)",
				},
				{
					key: "40-60",
					imageWrapperWidth: "40%",
					imageMediumWidth: "40vw",
					imageMediumMaxWidth: "560px",
					detailsWidth: "calc(60% - 10px)",
				},
				{
					key: "debug",
					imageWrapperWidth: "50%",
					imageMediumWidth: "50vw",
					imageMediumMaxWidth: "500px",
					detailsWidth: "calc(50% - 10px)",
				},
				

			],
			showDropship: false,
			dropship: {
				active: false,
				email: null,
				quantity: 1, 
				productOptionSetId: null, 
				productOptionSetLabel: null
				
			},
			createDropshipOrderSpinner: false,
			startY: 0,
			isPulling: false,
			triggerDistance: 80,
			triggered: false,
			

		


		};
	},
	computed: {

		

		canSendDropship(){

			if (!this.dropship.email || this.dropship.email.length < 6){
				return false;
			}

			if (!this.dropship.quantity > 0){
				return false;
			}

			if (!this.hasProductOptions){
				return true;
			}

			if (this.hasProductOptions && this.dropship.active && this.dropship.productOptionSetId > 0){
				return true;
			}

			return false;

		},

		settingEnableDropship(){
			return this.getSettingValue("ENABLE_DROPSHIP") == true;
		},

		baseModel() {
			return this.$store.getters[STORE_GETTER.BASE_MODEL]
		},

		inCategoryList(){
			const categoryPathIdListForProductId = this.$store.getters[STORE_GETTER.SEARCH_INDEX_MODEL]?.categoryPathIdListForProductId
			const categoryPathIdListForProduct = categoryPathIdListForProductId?.[parseInt(this.productId)] ?? [];

			if (categoryPathIdListForProduct){
				//
			}

			var categoryList = [];

			const categoryListAll = this.baseModel?.categoryModel?.categoryList
			if (categoryListAll){
				//
			}

			const categoryTree = this.baseModel?.categoryModel?.categoryTree;

			categoryPathIdListForProduct?.forEach(categoryId => {
				
				//const category = categoryListAll?.find(category => category.categoryId == categoryId)

				const category = categoryHelper.findInCategoryTree(categoryId, categoryTree)

				var categoryPath = [];
				category.pathIdList?.forEach(pathId => {

					//const categoryInPath = categoryListAll?.find(category => category.categoryId == pathId);
					const categoryInPath = categoryHelper.findInCategoryTree(pathId, categoryTree)

					if (categoryInPath){
						categoryPath.push(categoryInPath);
					}

				})

				if (category.productList?.includes(parseInt(this.productId))){
					categoryList.push({ category: category, categoryPath: categoryPath });
				}
				

				

				
				console.log('FP: inCategoryList: category:', category);
				
			})

			return categoryList;

//			return categoryPathIdListForProduct
		},

		fitMcModel(){
			const mcPathIdListForProductId = this.$store.getters[STORE_GETTER.SEARCH_INDEX_MODEL]?.mcPathIdListForProductId
			const mcPathIdListForProduct = mcPathIdListForProductId?.[parseInt(this.productId)] ?? [];


			const mcTree = this.baseModel?.mcTree

			var mcMap = new Map();

			var brandNameList = []; // för att kunna sortera enklare

			mcTree?.forEach(brand => {
				if (mcPathIdListForProduct.includes(brand.id)){
					console.log('FP: fitMcModel brand: ', brand.name);

					const brandName = brand.name;
					brandNameList.push(brandName);

					// loopa modeller 
					brand?.modelList?.forEach( mcModel => {
						if (mcPathIdListForProduct.includes(mcModel.mcId) ){
							console.log('FP: fitMcModel mcModell: ', mcModel.modelName);

	

							var mc = {brand: brand, mcModel: mcModel, yearList: []};

							

							// loopa åren
							mcModel?.yearList?.forEach( year => {
								//console.log('FP: fitMcModel year: ', year.year);


								// kolla om produkten är inlagd på det året
								year?.productList?.forEach(productId => {
									if (productId == parseInt(this.productId)){
										console.log('FP: fitMcModel year: ', year.year);

										
										mc.yearList.push(year)

										
									}
								})
								
							})

							// om vi har en träff så addera ett objekt med mc 
							if (!mcMap.has(brandName)) {
								mcMap.set(brandName, []);
							}

							mcMap.get(brandName).push(mc);

						}
					})
				}
			})

			// loopa baseModel.mcTree övesta nivån och om det är träff på mcTree .id så lägg till märket i mappen, .name 
			// loopa märkets mc modeller, .modelList och om mcId finns med i listan så addera mc 
			// på mc finns .yearList som innehåller  ett year-object med .year "2026" och productList med id till de produkter som passar det året. 

			// sortera brandName
			brandNameList.sort((a, b) => {
				return (a || '').toLowerCase().localeCompare((b || '').toLowerCase());
			});

			// sortera alla modellerna
			mcMap.forEach((mcList, key) => {

				if (key){
					//
				}

				mcList.sort((a, b) => {
					return (a?.mcModel?.modelName || '').localeCompare(b?.mcModel?.modelName || '');
				});

				// sortera åren
				mcList.forEach(mc => {

					// sortera yearList på varje mc
					mc.yearList?.sort((a, b) => {
						return (a?.year || '').localeCompare(b?.year || '');
					});

				});

			});

			


			console.log('FP: fitModel: model: ', mcMap);
			

			return { mcMap: mcMap, brandNameList: brandNameList };





		},

		viewedProductIdList(){
			var productIdList = this.$store.getters[PRODUCT_STORE_GETTER.VIEWED_PRODUCT_ID_LIST];
			productIdList = productIdList?.filter(productId => productId != this.productId)

			//productIdList = productIdList.reverse();

			return productIdList
		},


		layout(){

			// antal kolumner som har mer än ett värde

			if (this.debug){
				return this.layoutList[3];
			}

			if (this.productOptionTableSizeSmall){
				return this.layoutList[1];
			}

			if (this.productOptionTableSizeLarge){
				return this.layoutList[2];
			}


			return this.layoutList[0];
		},

		hasProductOptions(){
			return this.productHasProductOptions(this.product);
		},

		imagePathList(){

			var imagePathList = [];

			if (this.product?.image){ // lägger in startbilden
				imagePathList.push({ path: settings.baseImagePath + this.product.image, debug: "startbild"});
			}

			if (this.product.details && this.product.details.itemList) {
				this.product.details.itemList.filter(item => item !== null && item.type == 'IMG').sort((a, b) => b.sort - a.sort).forEach(image => {

					const imagePath = settings.baseImagePath + image.data;

					if (imagePathList.find(currentImagePath => currentImagePath.path == imagePath) == null){
						imagePathList.push({ path: imagePath, debug: "IMG" });
						//imagePathList.push({ path: imagePath, debug: "IMG" });
						//imagePathList.push({ path: imagePath, debug: "IMG" });
						//imagePathList.push({ path: imagePath, debug: "IMG" });
					}
					
				});
			}

			//return [imagePathList[0]];
			return imagePathList;


		},

		getSelectedImagePath(){
			if (this.selectedImagePath == null && this.imagePathList?.length > 0){

				return this.imagePathList[0];

			}else if(this.selectedImagePath){
				return this.selectedImagePath
			}

			return null;
		},

		getBaseImagePath(){
			return settings.baseImagePath + "/";
		},


		product() {

			/*console.log('FP: product: ', this.$route.params);
			
			if (this.$route.params.productId > 0){

				const productId = this.$route.params.productId
				return this.$store.state.productStore.data.productList[productId]
			}
			return null*/

			if(this.productId > 0){
				return this.$store.state.productStore.data.productList[this.productId]
			}

			return null;

		},

		src() {
			return "https://public.boove.se/gfx/logos/" + this.product?.manufactorId + ".jpg"
		},

		categoryIdList(){
			return this.product?.details?.categoryIdList
		},

		categoryId(){
			if (this.categoryIdList && this.categoryIdList.length > 0){
				return this.categoryIdList[0];
			}

			return null;
			
		},

		category(){
			
			

			const categoryModel = this.$store.getters[STORE_GETTER.CATEGORY_MODEL];
			

			console.log('FP: categoryModel: ', categoryModel);
			
			const categoryTree = categoryModel?.categoryTree

			if (this.categoryId && categoryTree){
				//return categoryHelper.findInCategoryTree(this.categoryId, categoryTree);
				return categoryHelper.findInCategoryTree(this.categoryId, categoryTree);
			}

			return null;
			
		},

		/*
		category(){
			
			

			const categoryTree = this.baseModel?.categoryModel?.categoryTree;

			console.log('FP: categoryModel: ', this.baseModel?.categoryModel);
			
			

			if (this.categoryId && this.baseModel?.categoryModel?.categoryTree){
				//return categoryHelper.findInCategoryTree(this.categoryId, categoryTree);
				return categoryHelper.findInCategoryTree(this.categoryId, categoryTree);
			}

			return null;
			
		},*/

		showLeftIconLarge(){
			return this.largeImageIndex > 0
		},

		showRightIconLarge(){
			return this.largeImageIndex + 1 < this.imagePathList?.length
		},

		showLeftIconMedium() {
			return this.mediumImageIndex > 0
		},

		showRightIconMedium() {
			return this.mediumImageIndex + 1 < this.imagePathList?.length
		},

		baseCategoryModel() {

			return this.$store.getters[STORE_GETTER.CATEGORY_MODEL];
			/*
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.categoryModel) {
				return baseModel.categoryModel
			}

			return null;*/
		},

		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		productList() { // förenklad variant av produktlistan som är i sökningen på produkt-list-sidan

			const model2 = this.searchProductConfig.model2;

			var productList = [];

			if(this.productGroup && this.productGroup.key != null){

				productList = this.$store.getters[STORE_GETTER.PRODUCT_LIST_FOR_SELECTED_PRODUCT_GROUP];

			}else{
				productList = model2.productList;
			}
			

			if (this.searchProductConfig && this.searchProductConfig.sort) {
				productList = listHelper.sortList(productList, this.searchProductConfig.sort.property, this.searchProductConfig.sort.desc);
			}

			return productList;

		},

		previousProduct(){

			for (let index = 0; index < this.productList?.length; index++) {
				const product = this.productList[index];
				if (product.productId == this.productId && this.productId){
					return this.productList[index - 1];
				}
			}
			return null;
		},

		nextProduct() {

			for (let index = 0; index < this.productList?.length; index++) {
				const product = this.productList[index];
				if (product.productId == this.productId && this.productId) {
					return this.productList[index + 1];
				}
			}
			return null;
		},

		// lista med alla typer och en lista av deras värden färg: röd, blå. För att hitta de som har samma värde för att inkludera eller exkludera
		productOptionTypeValueList(){

			var productOptionTypeValueList = []; 


			this.product?.details?.productOptionSetList?.forEach(productOptionSet => {
				productOptionSet?.productOptionList?.forEach(productOption => {
					const productOptionTypeId = productOption.productOptionTypeId;
					const productOptionValue = productOption.value + "";
					if (!productOptionTypeValueList[productOptionTypeId]) {
						productOptionTypeValueList[productOptionTypeId] = [productOptionValue]
					} else if (!productOptionTypeValueList[productOptionTypeId].includes(productOptionValue)) {
						productOptionTypeValueList[productOptionTypeId].push(productOptionValue)
					}
				})
			})

			console.log('FP: productOption: productOptionTypeValueList:', productOptionTypeValueList);
			
			return productOptionTypeValueList;
		},

		productOptionTypeIdListWithOneValue(){

			var productOptionTypeValueList = this.productOptionTypeValueList;

			var productOptionTypeWithOneValue = [];

			this.product?.details?.productOptionSetList?.forEach(productOptionSet => {
				productOptionSet?.productOptionList?.forEach(productOption => {

					const productOptionTypeId = productOption.productOptionTypeId;
					if (productOptionTypeValueList[productOptionTypeId]?.length == 1) {
						productOptionTypeWithOneValue.push(productOptionTypeId);
					}
				})
			})

			return productOptionTypeWithOneValue;

		},

		// antal kolumner minus de som alla innehåller samma värde och ska flyttas till egenskaper
		productOptionSize() {
			const productOptionTypeValueListLength = parseInt(this.productOptionTypeValueList?.filter(productOptionTypeValue => productOptionTypeValue != null)?.length)
			console.log('FP: productOption: productOptionTypeValueListLength', productOptionTypeValueListLength);

			const productOptionTypeIdListWithOneValue = parseInt(this.productOptionTypeIdListWithOneValue?.length)
			console.log('FP: productOption: productOptionTypeIdListWithOneValue', productOptionTypeIdListWithOneValue);

			var size = parseInt(productOptionTypeValueListLength - productOptionTypeIdListWithOneValue);

			return size;
		},

		productOptionTableSizeSmall(){
			return this.productOptionSize == 1
		},

		productOptionTableSizeLarge(){
			return this.productOptionSize > 1
		},


		productOptionModel(){


			console.log('FP: productOption: productOptionTypeIdListWithOneValue: ', this.productOptionTypeIdListWithOneValue);
			
			// gå igenom listan med productOptionSet och filtrera fram vilka vi ska ha med. 

			var model = {headerList: [], rowList:[]};

			// loopa igenom 

			this.product?.details?.productOptionSetList?.filter(productOptionSet => productOptionSet != null).sort((a, b) => a.sort - b.sort).forEach(productOptionSet => {

				const row = {};
				row.productOptionSet = productOptionSet

				var colMap = new Map;

				productOptionSet?.productOptionList?.filter(productOption => productOption != null).sort((a, b) => a.productOptionTypeId - b.productOptionTypeId).forEach(productOption => {
					const productOptionTypeId = productOption.productOptionTypeId;
					
					// om den ska finnas med eller flyttas till egenskaper
					if (!this.productOptionTypeIdListWithOneValue.includes(productOptionTypeId)){
						model.headerList[productOptionTypeId] = { productOptionTypeId: productOptionTypeId, typeValue: productOption.typeValue, typeWeb: productOption.typeWeb } // FP: Om index redan finns så skrivs det över

						colMap.set(productOptionTypeId, productOption);
					}
					
				})
				row.colMap = colMap

			


				model.rowList.push(row)
			})

			model.headerList = model.headerList.filter(header => header !== null); // rensar bort null värden. 

			console.log('FP: productOption: model: ', model);
			
			return model;



		},

		productOptionListWithSameValue(){ // appendar egenskaper-listan

			var productOptionList = [];


			// 
			this.product?.details?.productOptionSetList?.filter(productOptionSet => productOptionSet != null).sort((a, b) => a.sort - b.sort).forEach(productOptionSet => {

				const row = {};
				row.productOptionSet = productOptionSet


				productOptionSet?.productOptionList?.filter(productOption => productOption != null).sort((a, b) => a.productOptionTypeId - b.productOptionTypeId).forEach(productOption => {
					const productOptionTypeId = productOption.productOptionTypeId;

					// om den ska finnas med eller flyttas till egenskaper
					if (this.productOptionTypeIdListWithOneValue.includes(productOptionTypeId)) {
						//model.headerList[productOptionTypeId] = { productOptionTypeId: productOptionTypeId, typeValue: productOption.typeValue, typeWeb: productOption.typeWeb } // FP: Om index redan finns så skrivs det över

						if (!productOptionList[productOptionTypeId]){
							productOptionList[productOptionTypeId] = productOption;
						}
					}

				})

			})

			console.log('FP: productOption: productOptionList: ', productOptionList);

			return productOptionList?.filter(productOption => productOption != null );

		},


		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL]
		},

		productTypeSelected() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED]

		},



		display1390() {
			return this.display(1390);
		},		

		display1100(){
			return this.display(1100);
		},

		display900() {
			return this.display(900);
		},

		descriptionShort(){

			if (this.product?.details?.description?.length > 400){
				return this.product?.details?.description.substring(0, 400) + "...";
			}
			return this.product?.details?.description
		},

		showReadMore(){

			return this.product?.details?.description?.length > 400

		},

		connectedProductIdList() {
			var connectedProductIdList = this.product?.details?.connectedProductIdList.filter(connectedProductId => connectedProductId != null);

			this.testConnectedProductIdList?.forEach(productId => {
				connectedProductIdList.push(productId);
			})

			return connectedProductIdList

		},

		displayPrice() {
			return this.$store.getters[USER_STORE_GETTER.DISPLAY_PRICE1];
		},

		priceTitle(){

			if (!this.isLoggedIn){
				return "";
			}

			var title = this.product?.productId + "-X";
			if (this.product?.details?.price1){
				title += this.product?.details?.price1;
			}

			title += "-" + this.product?.artnr
			
			return title // this.product?.details?.price1
		}



		
	},

	watch: {
		/*'$route.params.productId': {
			
			handler: function (productId) {
				console.log("FP: watcher route: ", productId);
				//if (this.productId == null){
					this.productId = productId
					this.getProductDetails({ productId: this.productId });
				//alert('$route.params.productId')
				//}
				
			},
			immediate: true
		},*/

		'isLoggedIn': {
			handler: function(){
				this.getProductDetails({ productId: this.productId });
			}
		},

		'productId': {

			handler: function (productId) {
				console.log("FP: watcher productId: ", productId);
				//alert("details productId")
				this.getProductDetails({ productId: this.productId });
				this.$store.commit(PRODUCT_STORE_COMMIT.ADD_PRODUCT_ID_TO_PRODUCT_GROUP, { productId: this.productId, key: "VIEWED"});
				this.resetDropship();
				document.title = settings.defaultTitlePrefix + this.product.name;
				//this.$router.replace('/mc/product/' + this.productId + "/" + this.product.urlKey) // FP: <-- TODO router

				//var params = { ...this.$router.currentRoute?.value.params, productId: this.productId, urlKey: this.product.urlKey }
				//this.$router.replace({ name: "ProductDetails", params: params })

				//this.routerReplaceProduct(this.product);

			}
		},

		


	},
	
	methods: {

		resetDropship(){
			this.dropship.active = false;
			this.dropship.productOptionSetId = null;
			this.dropship.productOptionSetLabel = null;
			this.dropship.email = null;
			this.dropship.error = null;
			this.showDropship = false
		},

		showDescription(){
			//alert("showDescription")
			const productDescriptionDiv = this.$refs["product-description"];
			
			if (productDescriptionDiv){
				productDescriptionDiv.scrollIntoView({ behavior: 'smooth', block: "center", inline: "nearest" });
				//setTimeout(() => imageDiv.scrollIntoView({ behavior: behavior, block: "nearest", inline: "nearest" }), 0);
			}
			console.log('FP: this.ref', );
			

		},

		manufactorSelected(){
			alert("Funktionen kommer snart... ");
			//this.routerShowProductList()
		},
		categorySelected(category){

			//alert("categorySelected: " + category.categoryId);

			console.log('FP: selectedCategory: ', category);
			

	

			this.searchProductConfig.category = category
			this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, this.searchProductConfig)
			// FP: 2026 CO2 this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
			this.$store.dispatch({ type: STORE_ACTION.REBUILD_SEARCH_MODEL_ACTION }).then(() => {
				this.routerShowProductList();
			})

			

			//this.$router.push('/mc/products') // FP: <-- TODO router
		},

		mcSelected(brand, mc, year){
			if (brand && mc && year){
				//
			}

			this.resetSearchProductConfig();
			this.searchProductConfig.brand = brand
			this.searchProductConfig.mc = mc
			this.searchProductConfig.year = year
			this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, this.searchProductConfig)
			// FP: 2026 CO2 this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
			this.$store.dispatch({ type: STORE_ACTION.REBUILD_SEARCH_MODEL_ACTION }).then(() => {
				this.routerShowProductList();
			})


		},

		titleMc(mc){
			var title = "Visa produkter som passar: "
			title = title + " " + mc.brand?.name
			title = title + " " + mc.mcModel?.modelName

			return title;

		},

		titleMcYear(mc, year){

			var title = this.titleMc(mc);

			title = title + ", Årsmodell: " + year?.year
			return title;
		},

		titleCategory(category){
			console.log('FP: titleCategory: ', category);
			return "Visa alla produkter i kategori:\n" + category?.path 

		},

		buy() {

			var data = { currentOrderId: this.currentOrderId, post: { productId: this.productId, quantity: 1 } }
			this.$store.dispatch({ type: USER_STORE_ACTION.ADD_PRODUCT_TO_ORDER, data: data });
		},

		buyProductOption(productOptionSet) {

			const productOptionSetId = productOptionSet.productOptionSetId;

			if (this.dropship.active){
				this.dropship.productOptionSetId = productOptionSetId;
				this.dropship.productOptionSetLabel = productOptionSet.artnr
				this.dropship.error = null;
				
				return;
			}


			var data = { currentOrderId: this.currentOrderId, post: { productId: this.productId, productOptionSetId: productOptionSetId, quantity: 1 } }
			this.$store.dispatch({ type: USER_STORE_ACTION.ADD_PRODUCT_TO_ORDER, data: data });
		},

		createDropshipOrder(){

			if(!this.isLoggedIn){
				return;
			}

			if (!this.settingEnableDropship){
				return;
			}

			if (!this.dropship.email || this.dropship.email?.length < 6){
				this.dropship.error = "Felaktig e-post";
				return;
			}

			if (!this.dropship.quantity || this.dropship.quantity == 0) {
				this.dropship.error = "Felaktigt antal";
				return;
			}

			if (this.hasProductOptions && !this.dropship.productOptionSetId > 0) {
				this.dropship.error = "Välj den produktvariant du vill beställa";
				return;
			}


			/*if (!window.confirm("Skicka order?")){
				return;
			}*/

		
			
			//this.$router.push({ name: 'OrderListView'});



			var order = { email: this.dropship.email, productId: this.productId, quantity: this.dropship.quantity }

		

			if (this.dropship.active && this.dropship.productOptionSetId > 0){
				order.productOptionSetId = this.dropship.productOptionSetId
			}

			var data = { order: order, dropship: true }

			this.createDropshipOrderSpinner = true

			this.$store.dispatch({ type: USER_STORE_ACTION.CREATE_ORDER_DROPSHIP, data: data }).then(result => {
				console.log('FP: result: ', result);
				
				this.resetDropship();
				this.$emit("showSubMenuOrder");

			}).finally( () => {
				this.createDropshipOrderSpinner = false
			})

		},

		display(width){

				var result = {}

				result.productOptionListRight = "block";
				result.productOptionListBelow = "none"

			if (this.productOptionTableSizeLarge && width == 1100) {
				result.productOptionListRight = "none";
				result.productOptionListBelow = "block";
				return result
			}

				if (width == 900) {
					result.productOptionListRight = "none";
					result.productOptionListBelow = "block";
					return result
				}

				return result;

		},
		previous(){
			if (this.previousProduct?.productId > 0){
				//this.productId = this.previousProduct?.productId
				this.routerReplaceProduct(this.previousProduct);

			}
			
		},

		next(){
			if (this.nextProduct?.productId > 0) {
				//this.productId = this.nextProduct?.productId
				this.routerReplaceProduct(this.nextProduct);
			}
		},

		showPreviousLargeImage(){
			const imageId = "image-large-" + (this.largeImageIndex - 1);
			this.showFullSize(imageId, 'smooth');
		},

		showNextLargeImage(){
			const imageId = "image-large-" + (this.largeImageIndex + 1);
			this.showFullSize(imageId, 'smooth');

		},


		showFullSize(imageId, behavior){

			if (!behavior){
				behavior = "instant";
			}
			
			//alert(fullsizeImageId)
			const imageDiv = this.$refs.imageLarge.find(image => image.id == imageId);
			if (imageDiv) {
				this.showImageListLarge = true
				//fullsizeImageDiv.scrollIntoView({ block: "nearest", inline: "nearest" });
				setTimeout(() => imageDiv.scrollIntoView({ behavior: behavior, block: "nearest", inline: "nearest" }), 0);
				
			}

		
		},

		showPreviousMediumImage() {
			const imageId = "image-medium-" + (this.mediumImageIndex - 1);
			this.scrollToImage(imageId, 'smooth');
		},

		showNextMediumImage() {
			const imageId = "image-medium-" + (this.mediumImageIndex + 1);
			this.scrollToImage(imageId, 'smooth');

		},

		scrollToImage(imageId, behavior) {


			if (!behavior) {
				behavior = "instant";
			}

			const imageDiv = this.$refs.imageMedium?.find(image => image.id == imageId);

			if (imageDiv) {
				
				imageDiv.scrollIntoView({ behavior: behavior, block: "nearest", inline: "nearest" });
			}
			//console.log('FP:  this.$refs', this.$refs);
			//this.$refs.image3[0].scrollIntoView({ block: "nearest", inline: "nearest" });
			
		},


		reloadPressed(){
			this.getProductDetails({ productId: this.productId });
		},

		deleteProductPressed(){
			this.$store.commit(PRODUCT_STORE_COMMIT.DELETE_PRODUCT_TEST, this.productId)
		},

		onScrollSmall(){

			const imageList = this.$refs.imageListSmall;


			const imageWidth = imageList.scrollWidth / this.imagePathList.length;
			const imageIndex = parseInt(imageList.scrollLeft / imageWidth);
				console.log('FP: scroll: imageIndex: ', imageIndex)

				this.smallImageIndex = imageIndex;


		},

		onScrollMedium() {

			const imageList = this.$refs.imageListMedium;
			const imageWidth = imageList.scrollWidth / this.imagePathList.length;
			const imageIndex = parseInt(imageList.scrollLeft / imageWidth);
			console.log('FP: scroll: imageIndex: ', imageIndex)

			this.mediumImageIndex = imageIndex;
		},

		onScrollLarge() {

			const imageList = this.$refs.imageListLarge;
			const imageWidth = imageList.scrollWidth / this.imagePathList.length;
			const imageIndex = parseInt(imageList.scrollLeft / imageWidth);
			console.log('FP: scroll: imageIndex: ', imageIndex)

			this.largeImageIndex = imageIndex;
		},
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });



		getProductDetailsComplete() {
			console.log('FP: getProductDetailsComplete()');
			// kolla om det inte är några produkter laddade och hämta dem i så fall. 

			if (this.$store.getters[STORE_GETTER.BASE_MODEL] == null){
				this.$emit('getBaseModel')
			}else{
				console.log('FP: baseModel:', this.$store.getters[STORE_GETTER.BASE_MODEL]);
				
			}

			if (this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST]?.length < 100){
				console.log('FP: getProductDetailsComplete(), productList < 100');
				this.$emit('getProductRowList')
			}

			// samma med basemodel. 
		},

		

	},

	updated(){
		/*
		const images = this.$refs.imageList

		console.log('FP: this.$refs: ', this.$refs);

		alert(images);


		const observer = new IntersectionObserver((entries) => {
			console.log('FP: entries', entries);

		}, options);

		observer.observe(images);*/
		/*const images = document.querySelectorAll(".image");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry =>{
				//console.log('FP: entry', entry.target.id);
			})
			

		});*/

		/*images.forEach(image => {
			observer.observe(image);
		})*/

		
		
		

	},
	created() {

		//const productId = this.$route.params.productId 

		this.routerSetupProductUrl()

		
		
		if (this.productId > 0){
			
			//this.productId = productId
			this.getProductDetails({ productId: this.productId });
			this.$store.commit(PRODUCT_STORE_COMMIT.ADD_PRODUCT_ID_TO_PRODUCT_GROUP, { productId: this.productId, key: "VIEWED" });

			document.title = settings.defaultTitlePrefix

			if (this.product?.name){
				document.title = document.title + this.product.name
			}
			
		}

		//const productTypeKey = this.$route.params.productTypeKey

		
		console.log("FP: ROUTER:", this.$route);

		
		/*const options = {
			root: document.querySelector("#imageList"),
			rootMargin: "0px",
			scrollMargin: "0px",
			threshold: 1.0,
		};*/

		

		/*const intersectionObserver = new IntersectionObserver((entries) => {
			// If intersectionRatio is 0, the target is out of view
			// and we do not need to do anything.
			if (entries[0].intersectionRatio <= 0) return;

			alert("ok");
			console.log("Loaded new items");
		});*/


	},
	unmounted() {
		document.title = settings.defaultTitle
	}
};
</script>

<style>




 html body:has(div#imageListLarge.imageListLargeShow) {
	overflow: hidden;
	/**/
}

</style>

<style scoped>

hr{
	border:0px;border-top: 1px solid grey;
}

div#imageMediumWrapper{
flex-direction: column;
	padding: 5px;
	width: v-bind("layout.imageWrapperWidth"); /* 60% */
	position: relative;
	border: 0px solid blue;

	/* nedan justeras av media-query */
	position: sticky;
		top: 50px;
		overflow: scroll;
}

div#productView{
width: 100%;
	min-height: 400px;
	/*align-items: stretch;*/
	align-items:flex-start;
	flex-direction: row;
}

div.imageMediumWrapper{
	height: 100%;
		scroll-snap-align: center;
}

div.imageMediumWrapper img.imageMedium{
	height: calc(100% - 10px);
		width: v-bind("layout.imageMediumWidth");	/* 60vw */
		max-width: v-bind("layout.imageMediumMaxWidth"); /* 840px */
		object-fit: contain;
		padding: 0px;
}

div#details{
	padding:0px;
		width: v-bind("layout.detailsWidth"); /* calc(40% - 10px) */
		background: white;
		border: 0px solid red;
		/* nedan justeras av media-query */
		position: sticky;
		top: 50px;
		max-height: calc(100vh - 100px);
		overflow-y: auto;
		scrollbar-width: none;
}

div.largeImageArrowLeft{
position: fixed;
	top: calc(50vh - 15px);
	max-width: 1400px;
	margin-left: 10px;
}

div.largeImageArrowRight {
	position: fixed;
		top: calc(50vh - 15px);
		max-width: 1400px;
		margin-left: min(calc(100vw - 40px), calc(1400px - 50px));
}

div.largeImageArrowLeft div.circle.arrow, div.largeImageArrowRight div.circle.arrow{
	height: 30px;
	width: 30px;
}

div#productOptionListRight{
	display: block;
}

div#productOptionListBelow{
	display: none;
}

div#width1400 {
	display: block;
}

div#width1390 {
	display: none;
}

div#width1100{
	display: none;
}

div#width900 {
	display: none;
}

div#width768 {
	display: none;
}

table#productOptionListMulti {
	display: none;
}

table#productOptionListOne{
	display: table;
}

@media (max-width: 1390px) and (min-width: 1100px) {
	div#width1400 {
		display: none;
	}

	div#width1390 {
		display: block;
	}

	div#width1100 {
		display: none;
	}

		div#width900 {
			display: none;
		}

	div#width768 {
		display: none;
	}

	div#productOptionListRight {
		display: v-bind("display1390.productOptionListRight");
	}

	div#productOptionListBelow {
		display: v-bind("display1390.productOptionListBelow");
	}
}

@media (max-width: 1100px) and (min-width: 900px) {

	div#width1400 {
		display: none;
	}

	div#width1390 {
		display: none;
	}

	div#width1100 {
		display: block;
	}

		div#width900 {
			display: none;
		}

	div#width768 {
		display: none;
	}

	div#productOptionListRight {
		display: v-bind("display1100.productOptionListRight");
	}

	div#productOptionListBelow {
		display: v-bind("display1100.productOptionListBelow");
	}
}

@media (max-width: 900px) and (min-width: 768px) {

	div#width1400 {
		display: none;
	}

	div#width1390 {
		display: none;
	}

	div#width1100 {
		display: none;
	}

	div#width900 {
		display: block;
	}

	div#width768 {
		display: none;
	}

	div#productOptionListRight {
		display: v-bind("display900.productOptionListRight");
	}

	div#productOptionListBelow {
		display: v-bind("display900.productOptionListBelow");
	}
}


@media (max-width: 768px) { /* mobil-versionen */

	div#width1400 {
		display: none;
	}

	div#width1390 {
		display: none;
	}
			
	div#width1100 {
		display: none;
	}

		div#width900 {
			display: none;
		}

	div#width768 {
		display: block;
	}

	div.productOptionListRight {
		display: block;
	}
	
	div.productOptionListBelow {
		display: none;
	}

	/*table#productOptionListMulti {
		display: table;
	}*/

	/*table#productOptionListOne {
		display: none;
	}*/

	/*div#productOptionWideListOne{
		display: none;
	}*/

	div#imageMediumWrapper {
		width: calc(100% - 30px);
		border: 0px solid green;

		position: initial;
			top: initial;
			overflow: initial;

		
	}	

	

	div#productView {
		flex-direction: column;
	}

	div.imageMediumWrapper img.imageMedium {
		width: calc(100vw - 10px);
		max-width: 800px;
	}

	div#details {
		width: calc(100% - 10px);
		border: 0px solid pink;
		position: initial;
		top: initial;
		height: auto;
		max-height: unset;
		overflow: unset;
		scrollbar-width: initial;
	}

	div.largeImageArrowLeft div.circle.arrow,
	div.largeImageArrowRight div.circle.arrow {
		height: 20px;
		width: 20px;
	}

	div.largeImageArrowLeft {
		top: calc(50vh - 10px);
	}

	div.largeImageArrowRight {
		top: calc(50vh - 10px);
	}
}


div#details table tr td.label{
	font-weight: bold;
	color:grey;
}
div#details table tr td.value {
}

div#details table#propertyList tr td.label {
	font-weight: bold;
	padding:5px;
	font-size:90%;
	height:30px;
	width: 150px;
}

div#details table#propertyList tr td.value {
	font-size: 90%;
	width:auto;
	
}

table#propertyList tr td {
	background: var(--grey-3);
}

table#propertyList tr.odd td{
	background: var(--grey-1);

}

div.discountBadge {
	background: var(--bg-discount);
	color: white;
	font-weight: bold;
	border-radius: 3px;
	padding: 3px;
	padding-left: 5px;
	padding-right: 5px;
	font-size: 80%;


}

</style>